import { createUuid } from '@core/utils';

import { STORAGE_KEY } from '@/constants';

export interface RecentHistory {
  keyword: string;
  id: string;
}

export const recentHistory = {
  /** 최근 검색어 가져오기 */
  get: (): RecentHistory[] => {
    const history = localStorage.getItem(
      STORAGE_KEY.GIFTS_SEARCH_RECENT_KEYWORDS,
    );

    if (!history) {
      return [];
    }

    return JSON.parse(history);
  },

  /** 최근 검색어 추가 */
  add: (keyword: string) => {
    let history = recentHistory.get();

    // 이미 있는 keyword면 기존 값 삭제
    history = history.filter((item) => item.keyword !== keyword);

    // 맨 앞에 추가
    history.unshift({ keyword, id: createUuid() });

    // 5개 초과 시 맨 뒤 제거
    if (history.length > 5) {
      history = history.slice(0, 5);
    }

    localStorage.setItem(
      STORAGE_KEY.GIFTS_SEARCH_RECENT_KEYWORDS,
      JSON.stringify(history),
    );
  },

  /** 최근 검색어 삭제 */
  delete: (id: string) => {
    const history = recentHistory.get();
    const filteredHistory = history.filter((item) => item.id !== id);
    localStorage.setItem(
      STORAGE_KEY.GIFTS_SEARCH_RECENT_KEYWORDS,
      JSON.stringify(filteredHistory),
    );
  },

  /** 최근 검색어 모두 삭제 */
  clear: () => {
    localStorage.removeItem(STORAGE_KEY.GIFTS_SEARCH_RECENT_KEYWORDS);
  },
};
